"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IssueDisplay = void 0;
const react_1 = __importDefault(require("react"));
const polaris_1 = require("@shopify/polaris");
const styled_components_1 = __importDefault(require("styled-components"));
const moment_1 = __importDefault(require("moment"));
const RenderLogic_1 = require("components/Dashboard/RenderLogic");
const StyledText_1 = require("components/Dashboard/Tables/StyledText");
const config_1 = require("assets/styles/config");
const ProblemOrdersIcon_1 = require("components/ProblemOrdersIcon");
// prettier-ignore
const statusMappings = {
    'available_for_pickup': 'Available for Pickup',
    'bad_tracking_code_error': 'Invalid Tracking Code',
    'cancelled': 'Cancelled',
    'delivered': 'Delivered',
    'error': 'Error',
    'failure': 'Failure to Deliver',
    'in_transit': 'In Transit',
    'out_for_delivery': 'Out for Delivery',
    'pending': 'Pending',
    'pre_transit': 'Pre-Transit',
    'return_to_sender': 'Returned to Sender',
    'unknown': 'Unknown'
};
const rulesMappings = {
    FulfillmentStalled: 'Stalled In Fulfillment',
    ShipmentStalled: 'Stalled In Transit',
    ShipmentReturnedToSender: 'Returned To Sender',
    ShipmentDeliveryAttempted: 'Delivery Attempted'
};
const StyledDataRow = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const ShipmentDataContainer = styled_components_1.default.div `
  border-bottom: 1px solid ${config_1.colors.pavement};
  padding: 18px 0;

  &:last-child {
    border: none;
  }
`;
const StyledColumnContainer = styled_components_1.default.div `
  align-items: ${({ left }) => (left ? 'flex-start' : 'flex-end')}};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 50%;
`;
const IssueContainer = styled_components_1.default.div `
  align-items: center;
  display: flex;
  justify-content: flex-start;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;

  .Polaris-Icon {
    margin-right: 0.2rem;
    margin-left: 0;
  }

  .Polaris-TextStyle--variationNegative {
    margin-left: 0.2rem;
  }
`;
const IssueDisplay = ({ issue }) => {
    const insertedAt = (0, moment_1.default)(issue.insertedAt);
    const formattedDate = insertedAt.format('MMM D');
    const formattedTime = insertedAt.format('h:mma');
    const formattedDateTime = `${formattedDate} at ${formattedTime}`;
    return (react_1.default.createElement(IssueContainer, { key: issue.id },
        react_1.default.createElement(ProblemOrdersIcon_1.ProblemOrdersIcon, null),
        react_1.default.createElement(polaris_1.TextStyle, { variation: 'negative' },
            rulesMappings[issue.rule.name],
            ": ",
            formattedDateTime)));
};
exports.IssueDisplay = IssueDisplay;
function renderStatus(status) {
    const statusString = statusMappings[status];
    return (react_1.default.createElement(StyledText_1.StyledText, { className: 'shipment-status', style: { marginBottom: '0.5rem' } }, statusString || 'Unknown'));
}
function renderData(data) {
    const dataMap = data.shipments.map((shipment) => {
        const issues = data.issues.edges.filter((issue) => { var _a; return ((_a = issue.node.shipment) === null || _a === void 0 ? void 0 : _a.id) === shipment.id; });
        return (react_1.default.createElement(ShipmentDataContainer, { key: shipment.id },
            react_1.default.createElement(StyledDataRow, null,
                react_1.default.createElement(StyledColumnContainer, { left: true },
                    (0, RenderLogic_1.renderTracking)(shipment),
                    react_1.default.createElement(StyledText_1.StyledText, { className: 'carrier-name', style: { marginBottom: '0.5rem', marginTop: '0.5rem' } }, shipment.carrierName)),
                react_1.default.createElement(StyledColumnContainer, null,
                    renderStatus(shipment.status),
                    (0, RenderLogic_1.renderArrival)(shipment.arrival))),
            issues.map((issue) => (react_1.default.createElement(exports.IssueDisplay, { issue: issue.node, key: issue.node.id }))) || null));
    });
    return react_1.default.createElement("div", null, dataMap);
}
// eslint-disable-next-line react/no-multi-comp
const ModalTable = (props) => {
    return react_1.default.createElement("div", null, renderData(props.data));
};
exports.default = ModalTable;
